import { render, staticRenderFns } from "./StorageCard.vue?vue&type=template&id=0c54dbe8&"
import script from "./StorageCard.vue?vue&type=script&lang=js&"
export * from "./StorageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports